import http from '@/services/http'

export default {
  authorize (payload) {
    return http.post('auth/authorize', payload)
  },
  passcode (payload) {
    return http.post('/auth/passcode', payload)
  },
  login (payload) {
    return http.post('/auth/login', payload)
  }
}
